import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

const LegacyProfileRedirect = () => {
  const { userId } = useParams();
  const location = useLocation();

  return (
    <Navigate
      to={`/p/${userId}${location.search}${location.hash}`}
      replace
    />
  );
};

export default LegacyProfileRedirect;
